import { Stack, Typography, useTheme } from "@mui/material";
import { Bell } from "lucide-react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { REMINDER_ICON_BOX_SIZE } from "web_myplann/Reminders/Config/reminderIconBox";
import { IconBox } from "web_myplann/Shared/Components/IconBox";

export const ReminderFlatEmptyRow = () => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<Stack
			direction="row"
			alignItems="center"
			px={theme.spacingTokens.lg}
			py={theme.spacingTokens.md}
			gap={theme.spacingTokens.md}
		>
			<IconBox bg={theme.palette.grey[100]} size={REMINDER_ICON_BOX_SIZE}>
				<Bell
					size={theme.iconSize.sm}
					color={theme.palette.grey[400]}
					aria-hidden
				/>
			</IconBox>
			<Typography variant="body2">
				{t(Resources.Reminders.Section.emptyTitle)}
			</Typography>
		</Stack>
	);
};
